import { Heading, Paragraph } from '@/atoms/Typography'
import styled from 'styled-components'

export const BlogCards = styled.div`
  padding: ${({ theme }) => theme.rem(32, 0)};
`

export const BlogCardsWrapper = styled.div``

export const BlogCardsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.rem(16)};
`

export const BlogCardsTitle = styled(Paragraph)``

export const BlogCardsDescription = styled(Paragraph)`
  max-width: 100%;

  ${({ theme }) =>
    theme.mediaQuery.md(
      `
    max-width: 80%;
  `
    )};
`
